module.exports = __webpack_public_path__ + "img/TECHNOLOGY-FRONX-BOOSTERGREEN-1.6fc13c82.jpg";